import { useState, useEffect, useRef } from "react";
import axios from "axios";
import "@/lonche.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const product = {
  brand: "LONCHE",
  name: "Konkan Style Sea Prawn Pickle",
  netWeightG: 200,
  priceINR: 400,
  whatsappDigits: "918779579879",
  phoneDisplay: "+91 87795 79879",
  fssai: "21526006603127",
  bestBeforeMonths: 3,
  instagramUrl: "https://www.instagram.com/eatlonche/",
  instagramHandle: "@eatlonche",
  email: "chefsher@lonche.in",
};
const MAX = 12;
const PACK = `${product.netWeightG} g`;
const ASSET = (name) => `/lonche_assets/${name}.jpg`;
const PHOTO = (name) => `/lonche_assets/${name}.webp`;
const SHOW_CHEFS = false;
const EAT_IMAGES = ["eat-topdown", "eat-rice", "eat-roti", "eat-bread", "eat-eggs", "eat-khichdi"];
const inr = (n) => "₹" + n.toLocaleString("en-IN");


const DICT = {
  en: {
    nav: { pickle: "The Pickle", chefs: "The Chefs", ingredients: "Ingredients", eat: "How to Eat", order: "Order", contact: "Contact" },
    menu: "Menu", close: "Close menu", open: "Open menu", backTop: "LONCHE, back to top",
    instagram: "Instagram", whatsapp: "WhatsApp", langSwitch: "Switch language",
    hero: {
      eyebrow: "Konkan recipe. Bolder flavour.",
      productLines: ["Konkan style", "Sea prawn", "Pickle"],
      line: `${PACK} | ${inr(product.priceINR)}`,
      cta: "Order on WhatsApp",
      support: "Konkan roots × Trained precision.",
    },
    truth: {
      eyebrow: "The Pickle",
      h: { l1: "From the sea.", l2: "From scratch.", accent2: false },
      body: "We use sea prawns, handpicked from the day’s fresh catch and prepared that same day using Chef Sagar’s family recipe. Every masala is made from scratch. No packet mixes.",
      close: "You can taste the difference.",
      alt: "Konkan sea prawn pickle lifted on a spoon over the open jar",
    },
    chefs: {
      eyebrow: "The Chefs",
      h: { l1: "2 Chefs &", l2: "a Pickle Project.", accent2: true },
      sagar: "Chef Sagar", sher: "Chef Sher",
      intro: "It started with a recipe from home.",
      body1: "Chef Sagar recreated his family’s Konkan Style Sea Prawn Pickle recipe, passed down through generations. Together, Chef Sagar and Chef Sher are bringing it to new tables.",
      body2: "This is where LONCHE begins. Next, we want to find more family pickle recipes, passed from one generation to the next, and recreate them for people everywhere.",
      close: "Family recipes. New tables.",
      altDuo: "Chef Sagar and Chef Sher in LONCHE t-shirts",
    },
    ingredients: {
      eyebrow: "The Ingredients",
      h: { l1: "What goes into", l2: "our Lonche.", accent2: true },
      items: ["Sea prawns", "Sunflower oil", "Salt", "Turmeric powder", "Rai (mustard seeds)", "Fresh curry leaves", "Hing (asafoetida)", "Kashmiri red whole chilli", "Green chilli", "Tamarind", "White vinegar", "Fresh ginger-garlic paste", "Konkan spices"],
      starNote: "Day’s fresh catch",
      support: "Every masala is made from scratch.",
      allergen: "Contains crustacean (sea prawns) and mustard.",
    },
    eat: {
      eyebrow: "How to Eat",
      h: { l1: "The correct way to eat Lonche:", l2: "There isn’t one.", accent2: true },
      small: "Your call.",
      pairingLine: "Rice. Roti. Bread. Eggs. Or a spoon.",
      body: "Straight from the jar or with your everyday meal. A little Konkan goes a long way.",
      options: ["Straight from the jar", "With rice", "With roti", "With bread", "With eggs", "With khichdi"],
      result: (p) => <>Lonche <strong>{p.toLowerCase()}</strong>.</>,
      altRice: "A plate of rice with a spoonful of Konkan sea prawn pickle",
      altOther: "Close-up of Konkan sea prawn pickle",
    },
    sticky: "Order",
    order: {
      eyebrow: "Order",
      h: { l1: "One jar.", l2: "All Konkan.", accent2: true },
      product: product.name,
      net: `Net wt. ${PACK}`,
      price: inr(product.priceINR),
      cta: "Order on WhatsApp",
      body: "Tap to order. We’ll confirm availability and delivery details for your pincode.",
      qtyLabel: "Jars", dec: "One fewer jar", inc: "One more jar", taxes: "Incl. of all taxes",
      ingTitle: "Ingredients",
      ingList: "Sea prawns, sunflower oil, salt, turmeric powder, rai (mustard seeds), fresh curry patta, hing (asafoetida), Kashmiri red whole chilli, green chilli, tamarind, white vinegar, fresh ginger garlic paste, Konkan spices.",
      allergen: "Contains crustacean (sea prawns) and mustard.",
      storage: "Store in a cool, dry place. Refrigerate after opening.",
      bestBefore: `Best before ${product.bestBeforeMonths} months from manufacture.`,
      fssai: `FSSAI Reg. No. ${product.fssai}`,
      trust: ["Made from scratch", "Delivery by pincode", "Order on WhatsApp"],
    },
    contact: {
      eyebrow: "Contact",
      h: { l1: "Ask us about", l2: "the pickle.", accent2: false },
      body: "Orders, delivery questions or a family pickle recipe you’d like to tell us about. We’d love to hear from you.",
      cta: "Chat on WhatsApp",
      phoneLabel: "Phone", emailLabel: "Email", igLabel: "Instagram",
      fssai: `FSSAI Reg. No. ${product.fssai}`,
      storage: "Store in a cool, dry place. Refrigerate after opening.",
      bestBefore: `Best before ${product.bestBeforeMonths} months from manufacture.`,
    },
    chicken: {
      badge: "Coming soon",
      h: { l1: "Maharashtrian", l2: "Chicken Pickle.", accent2: true },
      body: "Our next small-batch pickle — bold Maharashtrian chicken, made the same from-scratch way. Pre-order now and we'll message you the moment the first batch is ready.",
      cta: "Pre-order on WhatsApp",
      bar: "Maharashtrian Chicken Pickle — coming soon.",
      barCta: "Pre-order",
      preMsg: "Hi LONCHE! I'd like to pre-order the Maharashtrian Chicken Pickle. Please notify me when it's ready.",
    },
    copyright: `© ${new Date().getFullYear()} LONCHE.`,
    waMsg: (q, total) => `Hi LONCHE! I'd like to order ${q} jar(s) of Konkan Style Sea Prawn Pickle (${PACK}). Total: ₹${total}. My pincode is:`,
    waHi: "Hi LONCHE!",
  },
  mr: {
    nav: { pickle: "लोणचे", chefs: "शेफ", ingredients: "साहित्य", eat: "कसे खावे", order: "ऑर्डर", contact: "संपर्क" },
    menu: "मेनू", close: "मेनू बंद करा", open: "मेनू उघडा", backTop: "LONCHE, वर जा",
    instagram: "इन्स्टाग्राम", whatsapp: "व्हॉट्सॲप", langSwitch: "भाषा बदला",
    hero: {
      eyebrow: "कोकणची पाककृती. भरभरून चव.",
      productLines: ["कोकण पद्धतीचे समुद्री कोळंबीचे लोणचे"],
      line: `${PACK} | ${inr(product.priceINR)}`,
      cta: "व्हॉट्सॲपवर ऑर्डर करा",
      support: "कोकणची परंपरा × शेफचे कौशल्य.",
    },
    truth: {
      eyebrow: "आमचे लोणचे",
      h: { l1: "समुद्रातून.", l2: "सगळं सुरुवातीपासून.", accent2: false },
      body: "आम्ही समुद्री कोळंबीच वापरतो. दिवसाच्या ताज्या मासेमारीतून निवडलेली कोळंबी त्याच दिवशी शेफ सागर यांच्या कौटुंबिक पाककृतीनुसार तयार केली जाते. प्रत्येक मसाला आम्ही स्वतः बनवतो. तयार पाकिटातले मसाले नाहीत.",
      close: "फरक चवीत जाणवतो.",
      alt: "चमच्यावर कोकणी समुद्री कोळंबीचे लोणचे",
    },
    chefs: {
      eyebrow: "आमचे शेफ",
      h: { l1: "2 शेफ आणि", l2: "एक पिकल प्रोजेक्ट.", accent2: true },
      sagar: "शेफ सागर", sher: "शेफ शेर",
      intro: "सुरुवात झाली घरच्या एका पाककृतीपासून.",
      body1: "शेफ सागर यांनी त्यांच्या कुटुंबात पिढ्यानपिढ्या जपलेली कोकण पद्धतीच्या समुद्री कोळंबीच्या लोणच्याची पाककृती पुन्हा तयार केली. शेफ सागर आणि शेफ शेर मिळून ही चव नव्या जेवणाच्या टेबलांपर्यंत पोहोचवत आहेत.",
      body2: "LONCHE ची ही सुरुवात आहे. पुढे, कुटुंबांमध्ये पिढ्यानपिढ्या चालत आलेल्या लोणच्याच्या आणखी पाककृती शोधायच्या आहेत. त्या पुन्हा तयार करून जगभरातील लोकांपर्यंत पोहोचवायची आमची इच्छा आहे.",
      close: "घरच्या पाककृती. नव्या पंगती.",
      altDuo: "LONCHE टी-शर्टमध्ये शेफ सागर आणि शेफ शेर",
    },
    ingredients: {
      eyebrow: "साहित्य",
      h: { l1: "आमच्या लोणच्यात", l2: "काय आहे.", accent2: true },
      items: ["समुद्री कोळंबी", "सूर्यफूल तेल", "मीठ", "हळद", "मोहरी", "ताजी कढीपत्त्याची पाने", "हिंग", "सुक्या अख्ख्या काश्मिरी लाल मिरच्या", "हिरवी मिरची", "चिंच", "पांढरा व्हिनेगर", "ताजी आले-लसूण पेस्ट", "कोकणी मसाले"],
      starNote: "त्याच दिवशीची ताजी मासळी",
      support: "प्रत्येक मसाला आम्ही स्वतः बनवतो.",
      allergen: "यामध्ये समुद्री कोळंबी (क्रस्टेशियन) आणि मोहरी आहे. या पदार्थांची ॲलर्जी असल्यास खाऊ नका.",
    },
    eat: {
      eyebrow: "कसे खावे",
      h: { l1: "LONCHE खाण्याची एकच योग्य पद्धत?", l2: "अशी कोणतीच नाही.", accent2: true },
      small: "तुमची मर्जी.",
      pairingLine: "भात. पोळी. ब्रेड. अंडी. किंवा थेट चमच्याने.",
      body: "थेट बरणीतून खा किंवा रोजच्या जेवणासोबत. थोडंसं लोणचे. भरपूर कोकणची चव.",
      options: ["थेट बरणीतून", "भातासोबत", "पोळीसोबत", "ब्रेडसोबत", "अंड्यांसोबत", "खिचडीसोबत"],
      result: (p) => <>LONCHE <strong>{p}</strong>.</>,
      altRice: "भातासोबत कोकणी समुद्री कोळंबीचे लोणचे",
      altOther: "कोकणी समुद्री कोळंबीच्या लोणच्याचे जवळून दृश्य",
    },
    sticky: "ऑर्डर करा",
    order: {
      eyebrow: "ऑर्डर",
      h: { l1: "एक बरणी.", l2: "कोकणची चव भरभरून.", accent2: true },
      product: "कोकण पद्धतीचे समुद्री कोळंबीचे लोणचे",
      net: `निव्वळ वजन ${PACK}`,
      price: inr(product.priceINR),
      cta: "व्हॉट्सॲपवर ऑर्डर करा",
      body: "ऑर्डर करण्यासाठी टॅप करा. तुमच्या पिनकोडनुसार उपलब्धता आणि डिलिव्हरीची माहिती आम्ही कळवू.",
      qtyLabel: "बरण्या", dec: "एक बरणी कमी करा", inc: "एक बरणी वाढवा", taxes: "सर्व करांसह",
      ingTitle: "साहित्य",
      ingList: "समुद्री कोळंबी, सूर्यफूल तेल, मीठ, हळद, मोहरी, ताजी कढीपत्त्याची पाने, हिंग, सुक्या अख्ख्या काश्मिरी लाल मिरच्या, हिरवी मिरची, चिंच, पांढरा व्हिनेगर, ताजी आले-लसूण पेस्ट, कोकणी मसाले.",
      allergen: "यामध्ये समुद्री कोळंबी (क्रस्टेशियन) आणि मोहरी आहे.",
      storage: "थंड आणि कोरड्या जागी ठेवा. उघडल्यानंतर फ्रिजमध्ये ठेवा.",
      bestBefore: "उत्पादनाच्या तारखेपासून 3 महिन्यांच्या आत वापरा.",
      fssai: `FSSAI नोंदणी क्रमांक: ${product.fssai}`,
      trust: ["सगळं सुरुवातीपासून", "पिनकोडनुसार डिलिव्हरी", "व्हॉट्सॲपवर ऑर्डर"],
    },
    contact: {
      eyebrow: "संपर्क",
      h: { l1: "लोणच्याबद्दल", l2: "आम्हाला विचारा.", accent2: false },
      body: "ऑर्डर, डिलिव्हरीचे प्रश्न किंवा तुमच्या कुटुंबातली एखादी लोणच्याची पाककृती. आम्हाला नक्की सांगा.",
      cta: "व्हॉट्सॲपवर बोला",
      phoneLabel: "फोन", emailLabel: "ईमेल", igLabel: "इन्स्टाग्राम",
      fssai: `FSSAI नोंदणी क्रमांक: ${product.fssai}`,
      storage: "थंड आणि कोरड्या जागी ठेवा. उघडल्यानंतर फ्रिजमध्ये ठेवा.",
      bestBefore: "उत्पादनाच्या तारखेपासून 3 महिन्यांच्या आत वापरा.",
    },
    chicken: {
      badge: "लवकरच येत आहे",
      h: { l1: "महाराष्ट्रीयन", l2: "चिकन लोणचे.", accent2: true },
      body: "आमचे पुढचे स्मॉल-बॅच लोणचे — झणझणीत महाराष्ट्रीयन चिकन, तेच सगळं सुरुवातीपासून बनवलेले. आत्ताच प्री-ऑर्डर करा, पहिली बॅच तयार होताच आम्ही तुम्हाला कळवू.",
      cta: "व्हॉट्सॲपवर प्री-ऑर्डर करा",
      bar: "महाराष्ट्रीयन चिकन लोणचे — लवकरच.",
      barCta: "प्री-ऑर्डर",
      preMsg: "नमस्कार LONCHE! मला महाराष्ट्रीयन चिकन लोणचे प्री-ऑर्डर करायचे आहे. तयार झाल्यावर मला कळवा.",
    },
    copyright: `© ${new Date().getFullYear()} LONCHE.`,
    waMsg: (q, total) => `नमस्कार LONCHE! मला कोकण पद्धतीच्या समुद्री कोळंबीच्या लोणच्याच्या (${PACK}) ${q} बरण्या ऑर्डर करायच्या आहेत. एकूण: ₹${total}. माझा पिनकोड:`,
    waHi: "नमस्कार LONCHE!",
  },
};

const getClickId = () => {
  let id = localStorage.getItem("lonche_cid");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random().toString(16).slice(2);
    localStorage.setItem("lonche_cid", id);
  }
  return id;
};

const Wordmark = () => (
  <>L<svg className="o" aria-hidden="true"><use href="#prawn" /></svg>NCHE</>
);

const IgIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.2" cy="6.8" r="1" fill="currentColor" stroke="none" />
  </svg>
);
const WaIcon = () => (<svg aria-hidden="true"><use href="#wa" /></svg>);

const LangToggle = ({ lang, onSet, className = "" }) => (
  <div className={`lang-toggle ${className}`} role="group" aria-label={DICT[lang].langSwitch} data-testid="lang-toggle">
    <button type="button" className={lang === "en" ? "active" : ""} aria-pressed={lang === "en"} onClick={() => onSet("en")} data-testid="lang-en">EN</button>
    <button type="button" className={lang === "mr" ? "active" : ""} aria-pressed={lang === "mr"} onClick={() => onSet("mr")} data-testid="lang-mr">मराठी</button>
  </div>
);

const Headline = ({ h }) => (
  <h2><span>{h.l1}</span><br /><span className={h.accent2 ? "accent" : ""}>{h.l2}</span></h2>
);

function Loader() {
  return null;
}

const StickyOrder = ({ t, waLink, logIntent }) => {
  const [show, setShow] = useState(false);
  const [q, setQ] = useState(1);
  useEffect(() => {
    const seen = {};
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { seen[e.target.id] = e.isIntersecting; });
      setShow(!seen.top && !seen.buy);
    });
    ["top", "buy"].forEach((id) => { const el = document.getElementById(id); if (el) io.observe(el); });
    return () => io.disconnect();
  }, []);
  return (
    <div className={`sticky-order${show ? " on" : ""}`} aria-hidden={!show} data-testid="sticky-order-bar">
      <div className="sticky-qty" role="group" aria-label={t.order.qtyLabel}>
        <button type="button" aria-label={t.order.dec} disabled={q <= 1} onClick={() => setQ(q - 1)} tabIndex={show ? 0 : -1} data-testid="sticky-qty-dec">−</button>
        <span className="sticky-qty-val" data-testid="sticky-qty-value">{q}</span>
        <button type="button" aria-label={t.order.inc} disabled={q >= 3} onClick={() => setQ(q + 1)} tabIndex={show ? 0 : -1} data-testid="sticky-qty-inc">+</button>
        <span className="sticky-total" data-testid="sticky-total">{inr(q * product.priceINR)}</span>
      </div>
      <a className="btn sticky-cta" href={waLink(q)} target="_blank" rel="noopener" onClick={() => logIntent(q)} tabIndex={show ? 0 : -1} data-testid="sticky-order-btn"><WaIcon />{t.sticky}</a>
    </div>
  );
};

export default function Landing() {
  const [qty, setQty] = useState(1);
  const [menuOpen, setMenuOpen] = useState(false);
  const [pairingIdx, setPairingIdx] = useState(0);
  const [lang, setLang] = useState(() => (localStorage.getItem("lonche_lang") === "mr" ? "mr" : "en"));
  const [fading, setFading] = useState(false);
  const firstRun = useRef(true);
  const t = DICT[lang];

  useEffect(() => {
    document.documentElement.lang = lang;
    document.body.classList.toggle("lang-mr", lang === "mr");
    localStorage.setItem("lonche_lang", lang);
    if (firstRun.current) { firstRun.current = false; return; }
    setFading(true);
    const id = setTimeout(() => setFading(false), 260);
    return () => clearTimeout(id);
  }, [lang]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") setMenuOpen(false); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  const total = qty * product.priceINR;
  const waLink = (q) => {
    const msg = q > 0 ? t.waMsg(q, (q * product.priceINR).toLocaleString("en-IN")) : t.waHi;
    return `https://wa.me/${product.whatsappDigits}?text=${encodeURIComponent(msg)}`;
  };

  const logIntent = (q) => {
    if (q <= 0) return;
    try {
      axios.post(`${API}/intents`, {
        quantity: q, unit_price: product.priceINR, total: q * product.priceINR,
        pack: PACK, referrer: document.referrer || null, click_id: getClickId(),
      }).catch(() => {});
    } catch (e) { /* never block the sale */ }
  };

  const waPreorder = `https://wa.me/${product.whatsappDigits}?text=${encodeURIComponent(t.chicken.preMsg)}`;
  const logPreorder = () => {
    try {
      axios.post(`${API}/intents`, { quantity: 1, unit_price: 0, total: 0, pack: "Chicken Pickle (pre-order)", referrer: document.referrer || null, click_id: getClickId() }).catch(() => {});
    } catch (e) { /* never block */ }
  };

  const navItems = [
    ["#buy", t.nav.order, "nav-order"],
    ["#truth", t.nav.pickle, "nav-truth"],
    ["#ingredients", t.nav.ingredients, "nav-ingredients"],
    ["#eat", t.nav.eat, "nav-eat"],
    ...(SHOW_CHEFS ? [["#chef", t.nav.chefs, "nav-chef"]] : []),
    ["#contact", t.nav.contact, "nav-contact"],
  ];

  const pairing = t.eat.options[pairingIdx];

  return (
    <>
      <a className="announce" href={waPreorder} target="_blank" rel="noopener" onClick={logPreorder} data-testid="chicken-announce">
        <span className="announce-dot" aria-hidden="true"></span>{t.chicken.bar} <strong>{t.chicken.barCta} →</strong>
      </a>
      <header className="bar">
        <div className="wrap">
          <a className="wm" href="#top" aria-label={t.backTop} data-testid="brand-logo"><Wordmark /></a>
          <ul className="nav-links">
            {navItems.map(([href, label, tid]) => (
              <li key={href}><a className={href === "#buy" ? "go" : ""} href={href} data-testid={tid}>{label}</a></li>
            ))}
          </ul>
          <div className="bar-actions">
            <a className="icon-link" href={product.instagramUrl} target="_blank" rel="noopener" aria-label={t.instagram} data-testid="nav-instagram"><IgIcon /></a>
            <a className="icon-link" href={waLink(0)} target="_blank" rel="noopener" aria-label={t.whatsapp} data-testid="nav-whatsapp"><WaIcon /></a>
            <LangToggle lang={lang} onSet={setLang} className="bar-lang" />
            <button className="menu-btn" type="button" aria-expanded={menuOpen} aria-controls="menu" aria-label={t.open} onClick={() => setMenuOpen(true)} data-testid="menu-open-btn"><span></span></button>
          </div>
        </div>
      </header>

      <div className="overlay" id="menu" hidden={!menuOpen} role="dialog" aria-modal="true" aria-label={t.menu}>
        <div className="top">
          <span className="wm" aria-hidden="true"><Wordmark /></span>
          <button className="close-btn" type="button" aria-label={t.close} onClick={() => setMenuOpen(false)} data-testid="menu-close-btn">×</button>
        </div>
        <ul>
          {navItems.map(([href, label]) => (
            <li key={href}><a className={href === "#buy" ? "go" : ""} href={href} onClick={() => setMenuOpen(false)}>{label}</a></li>
          ))}
        </ul>
        <div className="overlay-actions">
          <a className="icon-link" href={product.instagramUrl} target="_blank" rel="noopener" aria-label={t.instagram}><IgIcon /></a>
          <a className="icon-link" href={waLink(0)} target="_blank" rel="noopener" aria-label={t.whatsapp}><WaIcon /></a>
          <LangToggle lang={lang} onSet={(l) => { setLang(l); }} />
        </div>
      </div>

      <main className={fading ? "lang-fade" : ""} data-testid="site-main">
        {/* HERO */}
        <section className="hero" id="top">
          <div className="wrap">
            <div className="hero-copy">
              <div className="sec-head">
                <p className="kicker">{t.hero.eyebrow}</p>
                <LangToggle lang={lang} onSet={setLang} className="sec-lang" />
              </div>
              <div className="hero-logo wm" aria-label="LONCHE"><Wordmark /></div>
              <h1 className="hero-product">
                {t.hero.productLines.map((l, i) => (<span key={i}>{l}{i < t.hero.productLines.length - 1 && <br />}</span>))}
              </h1>
            </div>
            <figure className="pframe hero-photo" data-testid="hero-photo">
              <img src={PHOTO("hero-labelled-jar")} alt={`${product.brand} ${product.name}, ${PACK} jar`} width="1402" height="1122" fetchPriority="high" />
            </figure>
            <div className="hero-buy">
              <p className="hero-line">{t.hero.line}</p>
              <a className="btn hero-cta" href={waLink(1)} target="_blank" rel="noopener" onClick={() => logIntent(1)} data-testid="hero-order-btn"><WaIcon />{t.hero.cta}</a>
              <p className="hero-support">{t.hero.support}</p>
            </div>
          </div>
        </section>

        {/* ORDER */}
        <section className="buy dark pad" id="buy">
          <div className="wrap">
            <div className="buy-intro">
              <div className="sec-head"><p className="eyebrow">{t.order.eyebrow}</p><LangToggle lang={lang} onSet={setLang} className="sec-lang" /></div>
              <Headline h={t.order.h} />
            </div>
            <figure className="pframe order-photo" data-testid="order-photo">
              <img src={PHOTO("order-packshot")} alt={`${product.brand} ${product.name}, ${PACK}`} width="1122" height="1402" loading="lazy" />
            </figure>
            <div className="order">
              <div className="qty-row">
                <div>
                  <span className="lbl" id="qty-lbl">{t.order.qtyLabel}</span>
                  <div className="stepper" role="group" aria-labelledby="qty-lbl">
                    <button type="button" aria-label={t.order.dec} disabled={qty <= 1} onClick={() => setQty((q) => Math.max(1, q - 1))} data-testid="qty-decrease-btn">−</button>
                    <output aria-live="polite" data-testid="qty-value">{qty}</output>
                    <button type="button" aria-label={t.order.inc} disabled={qty >= MAX} onClick={() => setQty((q) => Math.min(MAX, q + 1))} data-testid="qty-increase-btn">+</button>
                  </div>
                </div>
                <div className="total"><span data-testid="order-total">{inr(total)}</span><small>{t.order.taxes}</small></div>
              </div>
              <a className="btn" href={waLink(qty)} target="_blank" rel="noopener" onClick={() => logIntent(qty)} data-testid="main-order-btn"><WaIcon />{t.order.cta}</a>
              <p className="order-body">{t.order.body}</p>

              <article className="label" aria-labelledby="lbl-title">
                <div className="label-head">
                  <h3 id="lbl-title">{t.order.product}</h3>
                  <svg className="nv" viewBox="0 0 26 26" role="img" aria-label="Non-vegetarian">
                    <rect x="1" y="1" width="24" height="24" fill="#f3ebdd" stroke="#7b3f1d" strokeWidth="2" />
                    <circle cx="13" cy="13" r="6" fill="#7b3f1d" />
                  </svg>
                </div>
                <p><strong>{t.order.ingTitle}:</strong> {t.order.ingList}</p>
                <p className="allergen">{t.order.allergen}</p>
                <div className="meta">
                  <span><strong>{t.order.net}</strong> &nbsp; <strong>MRP</strong> {t.order.price} ({t.order.taxes})</span>
                  <span>{t.order.storage}</span>
                  <span>{t.order.bestBefore}</span>
                  <span className="fssai">{t.order.fssai}</span>
                </div>
              </article>

              <ul className="trust">
                {t.order.trust.map((label, i) => (
                  <li key={i}>
                    <svg viewBox="0 0 24 24">{i === 0 ? <><path d="M4 7h16v13H4z" /><path d="M9 7V4h6v3" /></> : i === 1 ? <><path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z" /><circle cx="12" cy="9.5" r="2.5" /></> : <><path d="M3 5h12v9H3z" /><path d="M15 8h3l3 3v3h-6" /><circle cx="7" cy="17" r="1.6" /><circle cx="18" cy="17" r="1.6" /></>}</svg>
                    {label}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        {/* THE PICKLE */}
        <section className="truth dark pad" id="truth">
          <div className="wrap">
            <div>
              <div className="sec-head"><p className="eyebrow">{t.truth.eyebrow}</p><LangToggle lang={lang} onSet={setLang} className="sec-lang" /></div>
              <Headline h={t.truth.h} />
              <hr className="rule" />
              <p className="body">{t.truth.body}</p>
              <p className="body truth-close">{t.truth.close}</p>
            </div>
            <figure className="pframe truth-photo"><img src={PHOTO("pickle-spoon")} alt={t.truth.alt} width="1121" height="1403" loading="lazy" /></figure>
          </div>
        </section>

        {/* INGREDIENTS */}
        <section className="ingredients cream pad" id="ingredients">
          <div className="wrap">
            <div className="sec-head"><p className="eyebrow">{t.ingredients.eyebrow}</p><LangToggle lang={lang} onSet={setLang} className="sec-lang" /></div>
            <Headline h={t.ingredients.h} />
            <hr className="rule" />
            <ul className="ing-list" data-testid="ingredients-list">
              {t.ingredients.items.map((name, i) => (
                <li key={i} className={i === 0 ? "star" : undefined}>{name}{i === 0 && <small>{t.ingredients.starNote}</small>}</li>
              ))}
            </ul>
            <div className="ing-note">
              <p className="ing-support">{t.ingredients.support}</p>
              <p className="ing-allergen">{t.ingredients.allergen}</p>
            </div>
          </div>
        </section>

        {/* HOW TO EAT */}
        <section className="eat cream pad" id="eat" style={{ background: "var(--cream-2)" }}>
          <div className="wrap">
            <div className="txt">
              <div className="sec-head"><p className="eyebrow">{t.eat.eyebrow}</p><LangToggle lang={lang} onSet={setLang} className="sec-lang" /></div>
              <Headline h={t.eat.h} />
              <hr className="rule" />
              <p className="eat-pairings">{t.eat.pairingLine}</p>
              <p className="eat-lead">{t.eat.body}</p>
              <div className="eat-picker">
                <select className="eat-select" value={pairingIdx} onChange={(e) => setPairingIdx(Number(e.target.value))} aria-label={t.eat.eyebrow} data-testid="eat-pairing-select">
                  {t.eat.options.map((p, i) => (<option key={i} value={i}>{p}</option>))}
                </select>
                <p className="eat-result" data-testid="eat-pairing-result">{t.eat.result(pairing)}</p>
              </div>
            </div>
            <figure className="pframe eat-photo">
              <img key={pairingIdx} className="eat-swap" src={PHOTO(EAT_IMAGES[pairingIdx])} alt={`${pairing} – ${t.eat.altOther}`} width="1121" height="1403" loading="lazy" data-testid="eat-pairing-image" />
            </figure>
          </div>
        </section>

        {/* THE CHEFS (hidden for now) */}
        {SHOW_CHEFS && <section className="chef dark pad chefs" id="chef" style={{ background: "var(--char)" }}>
          <div className="wrap">
            <div className="chefs-head">
              <div className="sec-head"><p className="eyebrow">{t.chefs.eyebrow}</p><LangToggle lang={lang} onSet={setLang} className="sec-lang" /></div>
              <Headline h={t.chefs.h} />
            </div>
            <div className="chefs-grid">
              <figure className="pframe chefs-photo" data-testid="chefs-duo-photo">
                <img src={ASSET("chef_duo")} alt={t.chefs.altDuo} width="1122" height="1402" loading="lazy" />
              </figure>
              <div className="chefs-copy">
                <p className="chefs-tag">{t.chefs.intro}</p>
                <p className="body body-lead">{t.chefs.body1}</p>
                <p className="body body-amb">{t.chefs.body2}</p>
                <p className="chefs-close">{t.chefs.close}</p>
              </div>
            </div>
          </div>
        </section>}

        {/* CHICKEN TEASER */}
        <section className="chicken dark pad" id="chicken-pickle">
          <div className="wrap">
            <span className="chicken-badge" data-testid="chicken-badge">{t.chicken.badge}</span>
            <img className="chicken-logo" src={ASSET("chicken-logo")} alt="LONCHE Maharashtrian Chicken Pickle" loading="lazy" />
            <Headline h={t.chicken.h} />
            <p className="body chicken-body">{t.chicken.body}</p>
            <a className="btn btn-turmeric" href={waPreorder} target="_blank" rel="noopener" onClick={logPreorder} data-testid="chicken-preorder-btn"><WaIcon />{t.chicken.cta}</a>
          </div>
        </section>

        {/* CONTACT */}
        <section className="contact dark pad" id="contact">
          <div className="wrap">
            <div className="sec-head"><p className="eyebrow">{t.contact.eyebrow}</p><LangToggle lang={lang} onSet={setLang} className="sec-lang" /></div>
            <Headline h={t.contact.h} />
            <hr className="rule" />
            <p className="body contact-body">{t.contact.body}</p>
            <a className="btn contact-cta" href={waLink(0)} target="_blank" rel="noopener" data-testid="contact-whatsapp"><WaIcon />{t.contact.cta}</a>
            <ul className="contact-list">
              <li><span>{t.contact.phoneLabel}</span><a href={`tel:+${product.whatsappDigits}`} data-testid="contact-phone">{product.phoneDisplay}</a></li>
              <li><span>{t.contact.emailLabel}</span><a href={`mailto:${product.email}`} data-testid="contact-email">{product.email}</a></li>
              <li><span>{t.contact.igLabel}</span><a href={product.instagramUrl} target="_blank" rel="noopener" data-testid="contact-instagram">{product.instagramHandle}</a></li>
            </ul>
            <div className="contact-meta">
              <span>{t.contact.storage}</span>
              <span>{t.contact.bestBefore}</span>
              <span className="fssai">{t.contact.fssai}</span>
            </div>
          </div>
        </section>
      </main>
      <StickyOrder t={t} waLink={waLink} logIntent={logIntent} />

      <footer className="foot2">
        <div className="wrap">
          <span className="wm" aria-label="LONCHE"><Wordmark /></span>
          <small>{t.copyright}</small>
        </div>
      </footer>
    </>
  );
}
